import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { forwardRef as t } from "react";
import { b as l, C as i, c as h, R as m, T as d, A as C, a as p } from "../../index-iPWXV1sA.js";
import { c as e } from "../../cn-gv_k3DnN.js";
import { Button as k } from "../button/button.js";
const f = m;
f.displayName = "CoachMark";
const g = d;
g.displayName = "CoachMarkTrigger";
const M = C;
M.displayName = "CoachMarkAnchor";
const x = p;
x.displayName = "CoachMarkClose";
const u = t(({ className: a, children: o, ...c }, s) => /* @__PURE__ */ r(l, { children: /* @__PURE__ */ n(
  i,
  {
    ref: s,
    className: e(
      "bg-(--color-coach-mark-bg) p-sp-5 text-(--color-coach-mark-content) outline-(--color-coach-mark-bg) w-[calc(var(--fui-baseline)*13+var(--fui-subline)*3)] rounded-xl antialiased shadow-md",
      a
    ),
    ...c,
    arrowPadding: 24,
    align: "center",
    sideOffset: 8,
    children: [
      o,
      /* @__PURE__ */ r(h, { asChild: !0, children: /* @__PURE__ */ r(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "42",
          height: "16",
          viewBox: "0 0 42 16",
          className: "fill-(--color-coach-mark-bg)",
          children: /* @__PURE__ */ r("path", { d: "M41.382 0H.618a8 8 0 0 1 5.738 2.426l11.775 12.12a4 4 0 0 0 5.738 0l11.775-12.12A8 8 0 0 1 41.382 0Z" })
        }
      ) })
    ]
  }
) }));
u.displayName = "CoachMarkContent";
const T = ({
  className: a,
  ...o
}) => /* @__PURE__ */ r(
  "div",
  {
    className: e("mb-sp-2 gap-sp-3 flex w-full flex-col", a),
    ...o
  }
), B = ({
  className: a,
  ...o
}) => /* @__PURE__ */ r("h5", { className: e(a, "text-h5 font-sans text-xl"), ...o }), j = ({
  className: a,
  ...o
}) => /* @__PURE__ */ r("p", { className: e("text-body2", a), ...o }), P = ({
  className: a,
  ...o
}) => /* @__PURE__ */ r(
  "div",
  {
    className: e("mt-sp-5 gap-sp-2 flex items-center justify-end", a),
    ...o
  }
), N = t((a, o) => /* @__PURE__ */ r(
  k,
  {
    ref: o,
    ...a,
    className: e(
      a.className,
      "text-primary-inverted border-(--color-coach-mark-content)"
    ),
    size: "sm"
  }
));
N.displayName = "CoachMarkButton";
export {
  f as CoachMark,
  M as CoachMarkAnchor,
  N as CoachMarkButton,
  x as CoachMarkClose,
  u as CoachMarkContent,
  P as CoachMarkFooter,
  T as CoachMarkHeader,
  j as CoachMarkText,
  B as CoachMarkTitle,
  g as CoachMarkTrigger
};
